import CityPageTemplate from "../city-template/CityPageTemplate";
import { lorainConfig } from "./data";

export default function LorainPage() {
  return <CityPageTemplate config={lorainConfig} />;
}